const config = {
    dataUrl: `data/db.json`,
    modelsUrlRoot: 'models/',
    texturesUrlRoot: 'https://v3q4n5z4e3b0n2v3.s3-ap-southeast-1.amazonaws.com/',
    texturesUrlRootPoT: 'https://v3q4n5z4e3b0n2v3-pot.s3-ap-southeast-1.amazonaws.com/',
    environmentUrl: 'env/envSpecularHDR.dds',
}

export default config